import React, { useEffect, useRef, useState, useCallback } from "react";
import Portal from "./Portal";

const Modal = ({
  children,
  title = "",
  showClose = true,
  hideFooter = false,
  footer = null,
  show = false,
  onClose = () => {},
}) => {
  const [isOpen, setIsOpen] = useState(show);
  const modalContentRef = useRef(null);

  const closeModal = useCallback(
    (e) => {
      if (
        !e ||
        (modalContentRef.current && !modalContentRef.current.contains(e.target))
      ) {
        onClose();
        setIsOpen(false);
      }
    },
    [onClose]
  );

  useEffect(() => {
    setIsOpen(show);
  }, [show]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("click", closeModal, false);
    }
    return () => {
      if (isOpen) {
        document.removeEventListener("click", closeModal, false);
      }
    };
  }, [isOpen, closeModal]);

  return (
    <Portal>
      <React.Fragment>
        <div
          className={`modal fade ${isOpen ? "show" : ""}`}
          style={{
            display: isOpen ? "block" : "none",
          }}
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden={isOpen}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            ref={modalContentRef}
          >
            <div className="modal-content">
              <div className="modal-header">
                {title && (
                  <h5 className="modal-title" id="exampleModalLabel">
                    {title}
                  </h5>
                )}
                {showClose && (
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => closeModal()}
                  >
                    <span aria-hidden={isOpen}>&times;</span>
                  </button>
                )}
              </div>
              <div className="modal-body">{children}</div>
              {footer ? (
                <div className="modal-footer">{footer}</div>
              ) : !hideFooter ? (
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        {isOpen && (
          <div className={`modal-backdrop fade ${isOpen ? "show" : ""}`}></div>
        )}
      </React.Fragment>
    </Portal>
  );
};

export default Modal;
